// extracted by mini-css-extract-plugin
export var backdropBlur = "_mu-0";
export var contentCard = "_mu-5";
export var frame = "_mu-2";
export var image = "_mu-4";
export var imagePane = "_mu-3";
export var modal = "_mu-1";